import axios from 'axios'
import { Badge } from '@/domain/Badge'

/**
 * バッジサービス
 */
export default class BadgeService {
    /** インスタンス */
    private static _instance: BadgeService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new BadgeService();
        }
        return this._instance;
    }

    /**
     * バッジ情報を取得
     */
    public async info(): Promise<Badge> {
        return await axios.get("/api/badge")
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Badge)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }
}
